<template>
    <AccountModal :modelValue="isLoginOpened" @update:modelValue="closeAccountModal" class="login-modal">
        <LoginContent />
    </AccountModal>
</template>

<script lang="ts" setup>
import { computed } from "vue";

import AccountModal from "@/account/components/shared/account-modal.vue";
import LoginContent from "@/account/components/login/login-content.vue";
import useAuthenticationFlows, { authenticationStep } from "../composables/use-authentication-flows";

const { closeAccountModal } = useAuthenticationFlows();

const isLoginOpened = computed(
    () =>
        authenticationStep.value == "LoginWelcome" ||
        authenticationStep.value == "LoginPass" ||
        authenticationStep.value == "LoginPhone" ||
        authenticationStep.value == "ForgPinGen" ||
        authenticationStep.value == "ForgPinLog" ||
        authenticationStep.value == "ForgPinOk" ||
        authenticationStep.value == "ForgNewPass" ||
        authenticationStep.value == "ForgNewPassOk"
);
</script>
